export function Permission({ action, organization, resource }) {
  this.action = action;
  this.organization = organization;
  this.resource = resource;
}

Permission.prototype.getName = function () {
  return `${this.resource}-${this.action}`;
};

Permission.createMany = function (resource, actions) {
  return actions.map((action) => `${resource}-${action}`);
};
